import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/TypeFields'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class TypeFieldsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "TypeFieldsStore",
			variables: true,
		})
	}
}

export async function load_TypeFields(params) {
  await initClient()

	const store = new TypeFieldsStore()

	await store.fetch(params)

	return {
		TypeFields: store,
	}
}
